<template>
  <div class="flex-box">
    <v-head></v-head>
    <div class="main-content">
      <div class="content-box" :class="{'content-collapse':collapse}">
        <router-view></router-view>
      </div>
    </div>   
    <v-foot></v-foot> 
  </div>
</template>
<script>
import utils from '@/utils/utils'
import vHead from './Header.vue'
import vFoot from "./Footer.vue";
import bus from './bus'
export default {
  data() {
    return {
      tagsList: [],
      collapse: false,
      name: '',
      icp: ''
    }
  },
  components: {
    vHead,vFoot
  },
  created() {
    this.name = utils.getName()
    this.icp = utils.getICP()
    bus.$on('collapse', msg => {
      this.collapse = msg
    })

    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('tags', msg => {
      let arr = []
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name)
      }
      this.tagsList = arr
    })
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/Home.vue